import React, { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAllCoupon,
} from "../../../../features/admin/master/coupon/Slice";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { Controller, useForm } from "react-hook-form";

import { getAllVehicleCatWithoutType } from "../../../../features/admin/common/Slice";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";
const Add = ({ id, setId, setShowError, setSuccess, setErr }) => {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();

  const vehicleList = useSelector(
    (state) => state.common.all_vehicle_category_without_type
  );
  const vehicleType = [
    { value: "cab", label: "Cab" },
    { value: "transport", label: "Transport" },
  ];
  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    setError,
    getValues,
    control,
    watch,
    formState: { errors },
    reset,
    image_required = true,
  } = useForm();
  const imageFile = watch("image");

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        const responseData = res?.payload?.data?.data;
        reset(responseData);

        // Match the type string to the select option object
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    if (id !== "") {
      GetData(id);
    }
  }, [id]);

  const selectedType = watch("type");

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      // sendData.append("code", data?.code);
      sendData.append("minimum_fare", data?.minimum_fare);
      sendData.append("type", data?.type);
      sendData.append("title", data?.title);
      sendData.append("description", data?.description);
      sendData.append("discount", data?.discount);
      sendData.append("start_date", data?.start_date);
      if (data?.end_date) {
        sendData.append("end_date", data?.end_date);
      }

      if (data?.use_per_coupon) {
        sendData.append("use_per_coupon", data?.use_per_coupon);
      }

      sendData.append("use_per_customer", data?.use_per_customer);

      sendData.append("image", data?.image[0]);
      sendData.append(
        "vehicle_category_id",
        JSON.stringify(data?.vehicle_category_id)
      );
      let response;
      if (id) {
        response = await dispatch(Update({ id: id, data: sendData }));
      } else {
        response = await dispatch(Create(sendData));
      }
      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAllCoupon());
        await setId("");
        setSuccess(true);
        setModalShow(true);
        reset({
          name: "",
          vehicle_category_id: "",
          type: "",
          discount: "",
          minimum_fare: "",
          code: "",
          title: "",
          description: "",
          image: "",
          start_date: "",
          end_date: "",
          use_per_coupon: "",
          use_per_customer: "",
        });
        setTimeout(() => {
          setSuccess(false);
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
      }
      if (response.payload.status == 406) {
        await setError("vehicle_category_id", {
          type: "manual",
          message: response.payload.data.message,
        });
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add Namee", error);
    }
  };

  console.log(errors);

  useEffect(() => {
    dispatch(getAllVehicleCatWithoutType());
  }, [dispatch]);

  return (
    <>
      <div className="forms_section">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Vehicle Category</Form.Label>
                <Controller
                  name="vehicle_category_id"
                  control={control}
                  rules={{ required: "Select Vehicle Category" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      isMulti
                      options={vehicleList}
                      value={field.value || []} // keep selected values as objects
                      onChange={(selected) => {
                        field.onChange(selected || []); // store full objects
                      }}
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.vehicle_category_id
                            ? "red"
                            : baseStyles.borderColor,
                        }),
                      }}
                    />
                  )}
                />

                {errors.vehicle_category_id && (
                  <span className="text-danger">
                    {errors.vehicle_category_id.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Type</Form.Label>
                <Form.Select
                  {...register("type", {
                    required: "Type is required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.type,
                  })}
                >
                  <option value="">Select Type</option>
                  <option value="Percent">Percent</option>
                  <option value="Flat">Flat</option>
                </Form.Select>
                {errors.type && (
                  <span className="text-danger">{errors.type?.message}</span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>
                  {selectedType === "Percent" ? "Percent" : "Amount"}
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder={
                    selectedType === "Percent" ? "Percent" : "Amount"
                  }
                  {...register("discount", {
                    required: `${
                      selectedType === "Percent" ? "Percent" : "Amount"
                    } is Required`,
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.discount,
                  })}
                />
                {errors.discount && (
                  <span className="text-danger">{errors.discount.message}</span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>
                  <b>Minimum Fare</b>
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Minimum Fare"
                  min="0"
                  step="any" // ✅ allows decimal values
                  // onInput={(e) => {
                  //   e.target.value = Math.max(
                  //     0,
                  //     parseFloat(e.target.value) || 0
                  //   );
                  // }}
                  {...register("minimum_fare", {
                    required: selectedType === 'Percent' ? "Minimum Fare is Required" : false,
                    min: {
                      value: 0,
                      message: "Minimum Fare cannot be negative",
                    },
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.minimum_fare,
                  })}
                />

                {errors.minimum_fare && (
                  <span className="text-danger">
                    {errors.minimum_fare?.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>
                  <b>Use Per Coupon</b>
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Use Per Coupon"
                  min="0"
                  onInput={(e) => {
                    e.target.value = Math.max(
                      0,
                      parseFloat(e.target.value) || 0
                    );
                  }}
                  {...register("use_per_coupon", {
                    // required: "Use Per Coupon is Required",
                    min: {
                      value: 0,
                      message: "Use Per Coupon cannot be negative",
                    },
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.use_per_coupon,
                  })}
                />

                {errors.use_per_coupon && (
                  <span className="text-danger">
                    {errors.use_per_coupon?.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>
                  <b>Use Per Customer</b>
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Use Per Customer"
                  min="0"
                  onInput={(e) => {
                    e.target.value = Math.max(
                      0,
                      parseFloat(e.target.value) || 0
                    );
                  }}
                  {...register("use_per_customer", {
                    required: "Use Per Customer is Required",
                    min: {
                      value: 0,
                      message: "Use Per Customer cannot be negative",
                    },
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.use_per_customer,
                  })}
                />

                {errors.use_per_customer && (
                  <span className="text-danger">
                    {errors.use_per_customer?.message}
                  </span>
                )}
              </div>
            </div>

            {/* <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Code</Form.Label>
                <Form.Control
                  type="text"
                  name=""
                  placeholder="Code"
                  {...register("code", {
                    required: "Code is Required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.code,
                  })}
                />
                {errors.code && (
                  <span className="text-danger">{errors.code?.message}</span>
                )}
              </div>{" "}
            </div>
            <div className="col-lg-6 col-md-6 mb-3"></div> */}

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  as="textarea" // 🔹 tells React-Bootstrap to render textarea
                  rows={4} // 🔹 controls height
                  placeholder="    Enter Title"
                  {...register("title", {
                    required: "Title is required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.title,
                  })}
                />
                {errors.title && (
                  <span className="text-danger">{errors.title?.message}</span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea" // 🔹 tells React-Bootstrap to render textarea
                  rows={4} // 🔹 controls height
                  placeholder="   Enter description"
                  {...register("description", {
                    required: "Description is required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.description,
                  })}
                />
                {errors.description && (
                  <span className="text-danger">
                    {errors.description?.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Start Date</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Enter Start Date"
                  {...register("start_date", {
                    required: "Start Date is Required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.start_date,
                  })}
                />
                {errors.start_date && (
                  <span className="text-danger">
                    {errors.start_date?.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>End Date</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Enter End Date"
                  {...register("end_date", {
                    // required: "End Date is Required",
                    validate: (value) => {
                      if (!value) return true; // ✅ allow empty
                      const startDate = new Date(getValues("start_date"));
                      const endDate = new Date(value);
                      if (endDate < startDate) {
                        return "End Date cannot be before Start Date";
                      }
                      return true;
                    },
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.end_date,
                  })}
                />

                {errors.end_date && (
                  <span className="text-danger">
                    {errors.end_date?.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group
                className="form-field mb-3"
                controlId="formBasicEmail"
              >
                <Form.Label>Image</Form.Label>
                <Form.Control
                  className={classNames("", {
                    "is-invalid": errors?.image,
                  })}
                  type="file"
                  {...register("image", {
                    // required: image_required
                    //   ? "Image is required"
                    //   : image_required,
                    required:
                      typeof getValues("image") == "string"
                        ? false
                        : " Image is required",
                    validate: async (value) => {
                      // if (typeof value !== "string") {
                      //   const fileTypes = ["jpg", "png", "jpeg"];
                      //   const fileType = value[0].name?.split(".")[1];
                      //   if (!fileTypes.includes(fileType)) {
                      //     return `please upload a valid file format. (${fileTypes})`;
                      //   }
                      // }
                    },
                  })}
                  //   {...register("image", {
                  //     validate: (value) => {
                  //       const currentImage = getValues("image");

                  //       if (
                  //         image_required &&
                  //         typeof currentImage !== "string" &&
                  //         (!value || value.length === 0)
                  //       ) {
                  //         return "Image is required";
                  //       }

                  //       return true;
                  //     },
                  //   })}
                  accept=".jpg, .jpeg, .png"
                />
                {errors.image && (
                  <span className="text-danger">{errors.image.message}</span>
                )}
              </Form.Group>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group className="mb-3">
                <Form.Label className="text-center">Image Preview</Form.Label>
                {typeof getValues("image") == "string" ? (
                  <div className="image-preview-container">
                    <img
                      src={IDS.IMG_URL + getValues("image")}
                      alt="Preview"
                      className="image-preview"
                      style={{ width: "150px", height: "130px" }}
                    />
                  </div>
                ) : (
                  imageFile &&
                  imageFile?.length > 0 && (
                    <div className="image-preview-container">
                      <img
                        // src={URL.createObjectURL(getValues("image")[0])}
                        src={URL?.createObjectURL(imageFile[0])}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "100px", height: "100px" }}
                      />
                    </div>
                  )
                )}
              </Form.Group>
            </div>

            <div className="form_submit_div ">
              <div className="row">
                <div className="col-lg-4 mx-auto mb-3">
                  <div className="button_group">
                    <button
                      type="button"
                      className="closebtn theme_bg"
                      onClick={() => {
                        reset({ name: "" });
                        setId("");
                      }}
                    >
                      Clear
                    </button>
                    <button
                      type="button"
                      className="addbtn"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>

      <Successfull_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Add;
